<template>
  <!-- ファイル出力設定画面 -->
  <div id="PDashboardFileOutputSettingModal">
    <div class="modal-card" style="width: 920px;">
      <header class="modal-card-head">
        <p class="modal-card-title" style="color: whitesmoke;">ファイル出力設定</p>
      </header>
      <fieldset class="modal-card-body" :disabled="isErrorOccerred">
        <div class="file-output-body">
          <p style="justify-self: flex-start;">フォーマット種別</p>
          <div class="format-kind-body">
            <div style="display: flex; align-items: center;">
              <div class="text-radio">
                <b-radio v-model="selectedFormatKind" class="td_radio" name="フォーマット種別" :native-value="pDashboardFormatKind.text">
                  テキスト
                </b-radio>
              </div>
              <div class="datatype-label" style="width:130px;">データタイプ :</div>
              <div style="padding: 0px;">
                <select v-model="selectedTextDataType" :disabled="this.selectedFormatKind != pDashboardFormatKind.text">
                  <option v-for="textDataType in textDataTypeList" :key="textDataType.label1" :value="textDataType.value">{{ textDataType.label1 }}</option>
                </select>
              </div>
              <div class="format-label" style="padding: 0px 10px 0px 30px;">フォーマット :</div>
              <div style="padding: 0px;">
                <select v-model="selectedTextFormat" :disabled="this.selectedFormatKind != pDashboardFormatKind.text">
                  <option v-for="textFormat in textFormatList" :key="textFormat.label1" :value="textFormat.value">{{ textFormat.label1 }}</option>
                </select>
              </div>
            </div>
            <div style="display: flex; align-items: center;">
              <div class="pdf-radio">
                <b-radio v-model="selectedFormatKind" class="td_radio" name="フォーマット種別" :native-value="pDashboardFormatKind.pdf">
                  <div style="display: flex; margin:auto;">
                    <p style="margin: auto;">PDF</p>
                  </div>
                </b-radio>
              </div>
              <div class="reporttype-label" style="width:130px; font-size: 16px;">レポートタイプ :</div>
              <div style="padding: 0px;">
                <select v-model="selectedPdfReportType" :disabled="this.selectedFormatKind != pDashboardFormatKind.pdf">
                  <option v-for="pdfReportType in pdfReportTypeList" :key="pdfReportType.label1" :value="pdfReportType.value">{{ pdfReportType.label1 }}</option>
                </select>
              </div>
            </div>
            <div style="display: flex; align-items: center;">
              <div class="original-radio">
                <b-radio v-model="selectedFormatKind" class="td_radio" name="フォーマット種別" :native-value="pDashboardFormatKind.original">
                  <div style="display: flex; margin:auto;">
                    <p style="margin: auto;">オリジナル</p>
                  </div>
                </b-radio>
              </div>
              <div class="reporttype-label" style="width:130px; font-size: 16px;">平均使用時間 :</div>
              <div style="padding: 0px;">
                <select v-model="selectedAverageUsageMinutesType" :disabled="this.selectedFormatKind != pDashboardFormatKind.original">
                  <option v-for="averageUsageMinutesType in averageUsageMinutesTypeList" :key="averageUsageMinutesType.label1" :value="averageUsageMinutesType.value">{{ averageUsageMinutesType.label1 }}</option>
                </select>
              </div>
            </div>
          </div>
          <div style="display: flex; justify-content: space-between; margin-top: 5px;">
            <b-checkbox class="columnCheckBox" v-model="outputMultiFormatFlag" style="width: auto;">
              複数のフォーマットで出力する
            </b-checkbox>
            <b-button v-if="outputMultiFormatFlag" style="width: 110px; height:30px" @click="insertOutputList()" >追加</b-button>
          </div>
          <div v-if="outputMultiFormatFlag" class="margin-top" style="display:grid;">
            <div style="justify-self:flex-start;">出力一覧</div>
            <b-table
              id="pDashboardFileOutputTable"
              :data="outputList"
              :selected.sync="selectedRow"
              :columns="outputList.length ? [] : columns"
              :mobile-cards="false"
              style="border: 1px, black, solid; margin: 5px 0px; height: 120px;">
              <template slot-scope="props">
                <b-table-column style="padding: 1px 10px; border:none; width: 140px" label="種別">
                  <span>{{ props.row.formatKindName }}</span>
                </b-table-column>
                <b-table-column style="padding: 1px 10px; border:none; width: 480px" label="タイプ">
                  <span v-if="props.row.formatKind == pDashboardFormatKind.text">{{ props.row.textDataTypeName }}</span>
                  <span v-if="props.row.formatKind == pDashboardFormatKind.pdf">{{ props.row.pdfReportTypeName }}</span>
                  <span v-if="props.row.formatKind == pDashboardFormatKind.original">{{ props.row.averageUsageMinutesTypeName }}</span>
                </b-table-column>
                <b-table-column style="padding: 1px 10px; border:none; width: 220px" label="フォーマット">
                  <span v-if="props.row.formatKind == pDashboardFormatKind.text">{{ props.row.textFormatName }}</span>
                </b-table-column>
              </template>
            </b-table>
            <b-button style="justify-self:flex-end; width: 110px; height:30px" @click="deleteOutputList()" :disabled="!this.selectedRow">削除</b-button>
          </div>
          <div style="display:grid;">
            <b-checkbox class="columnCheckBox" v-model="lastOutputDateRegisterFlag" style="width:auto; color: red; justify-self:flex-start;">
              本日を出力対象の患者の「前回出力日」に登録する
            </b-checkbox>
          </div>
        </div>
      </fieldset>
      <footer class="modal-card-foot">
        <b-button class="is-primary" type="button" @click="outputReport()" :disabled="roleId == role.role_salesOffice || isErrorOccerred">作成</b-button>
        <b-button class="is-primary" type="button" @click="$parent.close()" >キャンセル</b-button>
      </footer>
    </div>
  </div>
</template>
<script>
import { choicesType, pDashboardFormatKind, role } from "@/components/mock/base/const.js";
const UNEXPECTED_ERROR = "予期しないエラーが発生しました。";

export default {
  name: "PDashboardFileOutputSettingModal",
  props: {
    checkedRows:{type:Array, default() {return [];}},
    displayTemplateSettingList:{type:Array, default() {return [];}},
  },
  data() {
    let userInfo = this.getUserInfo();
    return {
      choicesType: choicesType,                   // 選択肢マスタの定数
      role: role,                                 // 選択肢マスタの定数
      pDashboardFormatKind: pDashboardFormatKind, // フォーマット種別の定数
      pdfOutputWarningCount: null,                // PDF出力警告人数
      selectedFormatKind: null,                   // フォーマット種別
      textDataTypeList: null,                     // プルダウン(データタイプ)
      selectedTextDataType: null,                 // 選択されているプルダウン(データタイプ)のindex
      textFormatList: null,                       // プルダウン(フォーマット)
      selectedTextFormat: null,                   // 選択されているプルダウン(フォーマット)のindex
      pdfReportTypeList: null,                    // プルダウン(レポートタイプ)
      selectedPdfReportType: null,                // 選択されているプルダウン(レポートタイプ)のindex
      averageUsageMinutesTypeList: null,          // プルダウン(平均使用時間)
      selectedAverageUsageMinutesType: null,      // 選択されているプルダウン(平均使用時間)のindex
      outputMultiFormatFlag: null,                // 複数フォーマット出力フラグ
      outputList: [],                             // 出力一覧
      selectedRow: null,                          // 選択されている出力一覧の行
      lastOutputDateRegisterFlag: null,           // 前回出力日登録フラグ
      isErrorOccerred: false,                     // エラー発生時true
      roleId: userInfo.roleId,                    // ロールID
      columns: [{
        "field": "kind",
        "label": "種別",
        "width": 140,
      },{
        "field": "type",
        "label": "タイプ",
        "width": 480,
      },{
        "field": "format",
        "label": "フォーマット",
        "width": 220,
      }]
    };
  },
  methods: {
    // 日本語名取得
    getDisplayName: function(outputList) {
      let outputInfo = outputList;
      let formatKindName = outputInfo.formatKind == this.pDashboardFormatKind.text ? "テキスト" : outputInfo.formatKind == this.pDashboardFormatKind.pdf ? "PDF" : "オリジナル";
      outputInfo.formatKindName = formatKindName;
      outputInfo.textDataTypeName = this.textDataTypeList[outputInfo.textDataType].label1;
      outputInfo.textFormatName = this.textFormatList[outputInfo.textFormat].label1;
      outputInfo.pdfReportTypeName = this.pdfReportTypeList[outputInfo.pdfReportType].label1;
      if (formatKindName == "オリジナル") {
        // 診療報酬改定本リリース前に出力一覧にオリジナルレポートが含まれているユーザー
        if (!("averageUsageMinutesType" in outputInfo)) {
          // 平均使用時間タイプ：使用日に設定
          outputInfo["averageUsageMinutesType"] = this.averageUsageMinutesTypeList[0].value;
          outputInfo["averageUsageMinutesTypeName"] = this.averageUsageMinutesTypeList[0].label1;
        } else {
          outputInfo.averageUsageMinutesTypeName = this.averageUsageMinutesTypeList[outputInfo.averageUsageMinutesType].label1;
        }
      }
      return outputInfo;
    },
    // 作成ボタン押下
    outputReport: function() {
      // 「複数フォーマット出力」のチェックを入れているか確認する。
      if (this.outputMultiFormatFlag) { // チェックを入れている場合かつ、出力一覧が空欄の場合はエラーを表示して以降の処理を行わない
        if (!this.outputList || this.outputList.length == 0) {
          this.showErrorMessage("出力一覧にフォーマットを追加してください。");
          return
        }
      }
      let message = "ファイルを作成します。<br>よろしいでしょうか？";
      // PDF出力フラグ：PDF, オリジナルの場合 ONにする。
      let pdfOutputFlag;
      if (this.outputMultiFormatFlag) {
        // 複数フォーマットフラグがONの場合、出力一覧をチェック
        pdfOutputFlag = this.outputList.some(output => output.formatKind != pDashboardFormatKind.text);
      } else {
        // 複数フォーマットフラグがOFFの場合、フォーマット種別をチェック
        pdfOutputFlag = this.selectedFormatKind != pDashboardFormatKind.text;
      }
      // PDF出力フラグがtrueかつ、PDF出力警告人数より選択行数が大きい場合
      if (pdfOutputFlag && this.pdfOutputWarningCount < this.checkedRows.length) {
        message = message + "<br><br>作成が完了するまで時間が掛かる場合があります。<br>作成中は画面を閉じずにしばらくお待ちください。";
      }
      // 確認ダイアログを表示する。
      this.$dialog.confirm({
        title: "　",
        confirmText:"OK",
        cancelText: "キャンセル",
        message: message,
        cancelConfirm: () => {
          return;
        },
        onConfirm: () => {
          let _this = this;
          this.apiCall(
            function(client) {
              return client.apis.externalPDashboard.outputPDashboardReportPOST({
                body:{
                  formatKind: _this.selectedFormatKind,
                  textDataType: _this.selectedTextDataType,
                  textFormat: _this.selectedTextFormat,
                  pdfReportType: _this.selectedPdfReportType,
                  averageUsageMinutesType: _this.selectedAverageUsageMinutesType,
                  outputMultiFormatFlag: _this.outputMultiFormatFlag,
                  outputList: _this.outputList,
                  lastOutputDateRegisterFlag: _this.lastOutputDateRegisterFlag,
                  checkedRows: _this.checkedRows,
                  displayTemplateSettingList: _this.displayTemplateSettingList
                }
              });
            },
            function(result) {
              if (result && result.status == 200) {
                // ダウンロードするファイル情報を取得
                let fileInfo = result.headers["content-disposition"].split("=")[1];
                // ファイル情報からファイル名を取得
                let fileName = fileInfo.slice(fileInfo.lastIndexOf("\'") + 1);
                const blob = result.data;
                const link = document.createElement("a");
                link.href = window.URL.createObjectURL(blob);
                link.download = decodeURIComponent(fileName);
                // メッセージを表示する前にダウンロードを開始
                link.click();
                _this.showMessage("ファイルの作成が完了しました。");
              } else {
                _this.isErrorOccerred = true;
                // エラーメッセージ表示
                _this.showErrorMessage(UNEXPECTED_ERROR);
              }
            },
            function(result){
              _this.isErrorOccerred = true;
              // エラーメッセージ表示
              _this.showErrorMessage(result);
            }
          );
        }
      });
    },
    // 追加ボタン押下
    insertOutputList: function() {
      // 追加するフォーマットが重複していないことを確認する。
      for (let outputInfo of this.outputList) {
        if ((outputInfo.formatKind == this.selectedFormatKind && (
            (outputInfo.formatKind == this.pDashboardFormatKind.text && outputInfo.textDataType == this.selectedTextDataType && outputInfo.textFormat == this.selectedTextFormat) ||
            (outputInfo.formatKind == this.pDashboardFormatKind.pdf && outputInfo.pdfReportType == this.selectedPdfReportType) ||
            (outputInfo.formatKind == this.pDashboardFormatKind.original && outputInfo.averageUsageMinutesType == this.selectedAverageUsageMinutesType)
          ))) {
          this.showErrorMessage("このフォーマットは既に追加されています。");
          return;
        }
      }

      // 追加するフォーマットを出力一覧用データに変換する。
      let outputObj = {
        "formatKind": this.selectedFormatKind,
        "textDataType": this.selectedTextDataType,
        "textFormat": this.selectedTextFormat,
        "pdfReportType": this.selectedPdfReportType,
        "averageUsageMinutesType": this.selectedAverageUsageMinutesType,
      };
      // 日本語名を取得する。
      outputObj = this.getDisplayName(outputObj);
      // 出力一覧の末尾に追加する。
      this.outputList.push(outputObj);
    },
    // 削除ボタン押下
    deleteOutputList: function() {
      let _selectedOutputListIndex = this.outputList.indexOf(this.selectedRow);
      this.outputList.splice(_selectedOutputListIndex, 1);
      this.selectedRow = null;
    },
  },
  computed: {},
  async mounted(){
    // 1. 各種プルダウンの選択肢を取得して設定する。
    this.textDataTypeList = this.getChoiceList(choicesType.pDashboardTextDataType, false);
    this.textFormatList = this.getChoiceList(choicesType.pDashboardTextFormat, false);
    this.pdfReportTypeList = this.getChoiceList(choicesType.pDashboardPdfReportType, false);
    this.averageUsageMinutesTypeList = this.getChoiceList(choicesType.pDashboardAverageUsageMinutesType, false);
    // 2. 初期表示する検索条件を取得する。
    let lastSearchCondition;
    let _this = this;
    await this.apiCall(
      function(client) {
        return client.apis.externalPDashboard.getFileOutputConditionPOST({
          body: {}
        });
      },
      function(result) {
        if (result && result.status == 200) {
          // 前回の検索条件を取得
          lastSearchCondition = result.obj.lastSearchCondition;
          // PDF出力警告人数を取得
          _this.pdfOutputWarningCount = result.obj.pdfOutputWarningCount;
        } else {
          _this.isErrorOccerred = true;
          // エラーメッセージ表示
          _this.showErrorMessage(UNEXPECTED_ERROR);
        }
      },
      function(result) {
        _this.isErrorOccerred = true;
        // エラーメッセージ表示
        _this.showErrorMessage(result);
      }
    );
    // 前回の検索条件を取得、かつ、エラーではない場合
    if (lastSearchCondition && !this.isErrorOccerred) {
      // 3. 2から取得した前回の検索条件の「出力一覧」を1から取得した選択肢リストに合わせて日本語名を取得する。
      let outputList = [];
      let conditionList = JSON.parse(lastSearchCondition.outputList);
      if (conditionList) {
        for (const output of conditionList) {
          outputList.push(this.getDisplayName(output));
        }
      }
      // 4. 出力条件を初期設定する。
      this.selectedFormatKind = lastSearchCondition.formatKind;
      this.selectedTextDataType = lastSearchCondition.textDataType;
      this.selectedTextFormat = lastSearchCondition.textFormat;
      this.selectedPdfReportType = lastSearchCondition.pdfReportType;
      this.selectedAverageUsageMinutesType = lastSearchCondition.averageUsageMinutesType;
      this.outputMultiFormatFlag = lastSearchCondition.outputMultiFormatFlag;
      this.outputList = outputList;
      this.lastOutputDateRegisterFlag = lastSearchCondition.lastOutputDateRegisterFlag;
    }
  },
};
</script>
<style lang="scss" scoped>
.file-output-body {
  text-align: left;
  color:#363636;
  display:grid;
}
.file-output-body select, option {
  font-size: 15px;
}
.format-kind-body {
  display: grid;
  border: 1px, black, solid;
  margin: 5px 0px;
  padding: 5px 12px 5px 10px;
  min-height: 125px;
}
.text-radio, .pdf-radio, .original-radio {
  width: 146px;
  padding: 2px 0px;
  margin: 5px 0px;
  font-size:16px; 
  align-content: center;
  justify-content: space-between;
}
.datatype-label, .format-label, .reporttype-label {
  margin: 5px 0px;
  font-weight: normal;
  font-size:16px;
  align-content: center;
  justify-content: space-between;
}
.modal-card-foot {
  justify-content: flex-end;
}
#pDashboardFileOutputTable {
  position: relative;
}
#pDashboardFileOutputTable::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 1px;
  background: white;
}
</style>
<style lang="scss">
#pDashboardFileOutputTable .table-wrapper {
  overflow-y: scroll;
  min-height: 100%;
  max-height: 100%;
}
#pDashboardFileOutputTable .table-wrapper thead tr:nth-child(1) th
{
  position: -webkit-sticky;
  position: sticky;
  top: 1px;
  background-color: white;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/guest/patientdashboard/PDashboardFileOutputSettingModal.vue